<template>
  <table class="table" :style="`max-height: calc(100vh - ${rectTop + 30}px);`" ref="table">
    <div>
      <!-- filters -->
      <span v-if="filters.length" class="filter">
        <span
          v-for="(item, i) in filters"
          :key="i + 'filter'"
          class="filter__item"
          @click="openPopup(i)"
        >
          {{ item.name }}:
          <span class="item__selected">
            <span v-if="appliedFilters[i].length" class="item__selected-count">
              {{ appliedFilters[i].length }}
            </span>
            <span v-else>все</span>
          </span>
          <svg
            :class="{ active__icon: popups[i] }"
            style="margin-left: 7px"
            class="dropdown-icon"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" />
          </svg>

          <transition name="fade">
            <div v-if="popups[i]" class="item__popup" @click.stop>
              <div class="popup__filters">
                <SearchForm borderless style="margin-bottom: 20px" />
                <div class="popup__scroll">
                  <span
                    v-for="(item, filterIndex) in new Array(8).fill(
                      'Регулировка или рекламация'
                    )"
                    :key="filterIndex + 'filter'"
                    class="popup__scroll-item"
                    >
                    <svg @click="addFilter(item, i)" style="margin-right:10px" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 0L6 12" stroke="#1170B8" stroke-width="2"/>
                      <path d="M12 6L2.68221e-07 6" stroke="#1170B8" stroke-width="2"/>
                    </svg>
                    {{ item }}</span
                  >
                </div>
              </div>
              <div style="padding:10px">
                <div class="popup__scroll">
                  <span
                    v-for="(item, seletedIndex) in selectedPopupFilters[i]"
                    :key="seletedIndex + 'scroll2'"
                    class="popup__scroll-item"
                    >
                    <svg @click="deleteFilter(seletedIndex, i)" style="margin-right:9px; margin-left:2px" width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.48523 0.75736L0.999948 9.24264" stroke="#95A4C0" stroke-width="2"/>
                      <path d="M9.48523 9.24264L0.999949 0.757359" stroke="#95A4C0" stroke-width="2"/>
                    </svg>
                    {{ item }}</span
                  >
                </div>
              </div>
              <div class="popup__buttons">
                <AppButton @click.native="applieFilters(i)" width="170px" title="Применить" type="third" />
                <AppButton @click.native="clearFilters(i)" width="170px" title="Очистить" type="alt" />
              </div>
            </div>
          </transition>

          <!-- <div v-if="isPopupOpen" @click.stop="popups = popups.map(p => false)" class="back__field" /> -->
        </span>
      </span>

      <!-- table -->
      <thead>
        <tr>
          <th
            v-if="hasCheckbox"
            class="th__checkbox"
            :style="loading ? 'display:flex;max-width:41px' : null"
          >
            <AppCheckbox
              :checked="allItemsActive"
              @toggle-check="toggleActiveAll"
            />
          </th>
          <th
            v-for="(item, index) in headers"
            :key="index"
            @click="item.isSortable && sort(item.dispatchName, item.sortName, index)"
            :style="item.isSortable ? 'cursor:pointer': null"
            :class="{ numbered: numbered && index === 0 }"
            :width="numbered ? null : 100 / headers.length + '%'"
          >
            {{ item.title }}
            <span
              v-if="item.isSortable"
              class="drop-icon table__drop-icon"
              @click="$set(sortIndex, index, !sortIndex[index])"
            >
              <svg
                :style="
                  sortIndex[index] ? 'transform: rotate(180deg)' : null
                "
                class="dropdown-icon"
                viewBox="0 0 12 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L6 6L11 1"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
            </span>
          </th>
          <th v-if="isMenuControlsActive"></th>
        </tr>
      </thead>
      <tbody v-if="loading" class="preloader__parent">
        <Preloader background="#F3F5FF" style="position:sticky; left: 46%; margin: 10px 0" />
      </tbody>
      <tbody v-else-if="isSpecial">
        <!--этот компонент ждёт в values объекты { data: 'value', mod: '' }
        для того чтобы к каждой ячейки можно было передовать модификатор для уникальной стилизации-->
        <AppTableSpecialElem
          v-for="item in data"
          :key="item.id"
          :itemId="item.id"
          :values="item.values"
          :has-checkbox="hasCheckbox"
          :is-active="item.isActive"
          :is-deactive="item.deactive"
          :is-warning="item.warning"
          :is-menu-controls-active="isMenuControlsActive"
          :menu-controls="menuControls"
          :isControlsActive="item.isControlsActive"
          @edit-this-item="editItem(item.id)"
          @remove-this-item="removeItem(item.id)"
          @show-this-item="showItem(item.id)"
          @toggle-active="toggleActiveItem(item.id)"
          @toggle-controls="itemToggleControls(item.id)"
        />
      </tbody>
      <tbody v-else>
        <AppTableElem
          v-for="item in data"
          :key="item.id"
          :itemId="item.id"
          :values="item.values"
          :has-checkbox="hasCheckbox"
          :is-active="item.isActive"
          :is-deactive="item.deactive"
          :is-warning="item.warning"
          :is-menu-controls-active="isMenuControlsActive"
          :menu-controls="menuControls"
          :isControlsActive="item.isControlsActive"
          @edit-this-item="editItem(item.id)"
          @remove-this-item="removeItem(item.id)"
          @show-this-item="showItem(item.id)"
          @toggle-active="toggleActiveItem(item.id)"
          @toggle-controls="itemToggleControls(item.id)"
        />
      </tbody>
    </div>
  </table>
</template>

<script>
import AppTableElem from '@/components/page/table/AppTableElem.vue'
import AppTableSpecialElem from '@/components/page/table/AppTableSpecialElem'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import Preloader from '@/components/page/Preloader'
import SearchForm from '@/components/page/input/SearchForm'
import AppButton from '@/components/page/button/AppButton'

export default {
  name: 'app-table',
  components: {
    AppCheckbox,
    AppTableSpecialElem,
    AppTableElem,
    Preloader,
    SearchForm,
    AppButton
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    hasCheckbox: {
      type: Boolean,
      default: false
    },
    allItemsActive: {
      type: Boolean,
      default: false
    },
    isMenuControlsActive: {
      type: Boolean,
      default: false
    },
    menuControls: {
      type: Object,
      default: () => ({
        add: false,
        update: false,
        remove: false
      })
    },
    loading: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Array,
      default: () => []
    },
    numbered: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.rectTop = this.$refs.table.getBoundingClientRect().top
  },
  data () {
    return {
      sortIndex: new Array(this.headers.length).fill(false),
      popups: new Array(this.filters.length).fill(false),
      selectedPopupFilters: new Array(this.filters.length).fill([]),
      appliedFilters: new Array(this.filters.length).fill([]),
      rectTop: 0
    }
  },
  computed: {
    isPopupOpen () {
      return this.popups.some(p => p)
    },
    centerOfScrollTable () {
      return (window.innerWidth - (360 + 175)) / 2 - 40
    }
  },
  methods: {
    toggleActiveAll () {
      this.$emit('toggle-active-all')
    },
    toggleActiveItem (id) {
      this.$emit('toggle-active-item', id)
    },
    editItem (id) {
      this.$emit('edit-this-item', id)
    },
    removeItem (id) {
      this.$emit('remove-this-item', id)
    },
    itemToggleControls (id) {
      this.$emit('toggle-controls', id)
    },
    itemToggleChildren (id) {
      this.$emit('toggle-children', id)
    },
    showItem (itemId) {
      this.$emit('show-this-item', itemId)
    },
    sort (dispatchName, sortName, i) {
      if (dispatchName && sortName) {
        this.$store.dispatch(dispatchName, {
          name: sortName,
          descending: !this.sortIndex[i]
        })
      }
    },
    openPopup (i) {
      this.$set(this.selectedPopupFilters, i, this.appliedFilters[i])
      if (this.popups[i]) {
        this.$set(this.popups, i, false)
      } else {
        this.popups = this.popups.map(p => false)
        this.$set(this.popups, i, true)
      }
    },
    addFilter (filter, popupIndex) {
      const popupFilters = [...this.selectedPopupFilters[popupIndex], filter]
      this.$set(this.selectedPopupFilters, popupIndex, popupFilters)
    },
    deleteFilter (selectedIndex, popupIndex) {
      const selected = this.selectedPopupFilters[popupIndex]
      selected.splice(selectedIndex, 1)
      this.$set(this.selectedPopupFilters, popupIndex, selected)
    },
    applieFilters (popupIndex) {
      const applied = JSON.stringify(this.selectedPopupFilters[popupIndex])
      this.$set(this.appliedFilters, popupIndex, JSON.parse(applied))
    },
    clearFilters (popupIndex) {
      this.$set(this.appliedFilters, popupIndex, [])
      this.$set(this.selectedPopupFilters, popupIndex, [])
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/system/_vars";
@import "../../../assets/css/system/_mixins";

@import "./_table";

.filter {
  display: flex;
  align-items: center;
  padding: 0 14px;
  height: 50px;
  width: calc(100% + 10px);
  border-radius: 7px 7px 0 0;

  .filter__item {
    display: flex;
    align-items: center;
    color: #0e619f;
    margin-right: 15px;
    cursor: pointer;
    position: relative;

    .item__selected {
      margin-left: 7px;

      .item__selected-count {
        color: white;
        width: 19px;
        height: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f66d59;
        border-radius: 50%;
      }
    }

    .item__popup {
      display: flex;
      flex-direction: column;
      width: 377px;
      height: 443px;
      position: absolute;
      top: 140%;
      left: calc(100% - 26px);
      z-index: 1000;
      background: white;
      border-radius: 3px;
      box-shadow: 0px 7px 11px rgba(23, 63, 125, 0.25);
      cursor: auto;

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: -6px;
        left: 15px;
        margin: 0 auto;
        width: 10px;
        height: 10px;
        background: #f3f5ff;
        border: 1px solid $border_color;
        border-bottom: none;
        border-right: none;
        transform: rotate(45deg);
      }

      .popup__filters {
        background: #f3f5ff;
        height: 50%;
        padding: 10px;
      }

      .popup__buttons {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 10px;
        margin-top: auto;
      }

      .popup__scroll {
        display: flex;
        flex-direction: column;
        height: 128px;
        width: 100%;
        // margin: 10px;
        color: #697178;
        overflow: auto;

        svg {
          cursor: pointer;
        }

        &::-webkit-scrollbar {
          width: 7px;
          height: 10px;
        }

        &::-webkit-scrollbar-track {
          background-color: $color_third;
        }

        &::-webkit-scrollbar-thumb {
          background-color: $color_second-light;
          min-width: 300px;
        }

        .popup__scroll-item:not(:last-of-type) {
          margin-bottom: 15px;
        }
      }
    }

    // .back__field {
    //   position: fixed;
    //   top: 0;
    //   left: 0;
    //   display: block;
    //   width: 100vw;
    //   height: 100vh;
    //   z-index: 100;
    //   // background: rgba($color: #000000, $alpha: 0.5);
    //   cursor: auto;
    // }

    .active__icon {
      transform: rotate(180deg);
    }
  }
}

.preloader__parent {
  position: relative;
}

table {
  .th__checkbox {
    border-right:1px solid #C4C4C4;
    padding: 0 10px;
  }
  th:not(.th__checkbox):not(.numbered) {
    min-width: 180px !important;
  }
}
</style>
